export default __webpack_public_path__ + "static/media/br2_1.93625450.webp";